import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.scss'

const MediaMeasurementTabView = ({ tabs }) => {
  const [tab, setTab] = useState(tabs[0].title)

  return (
    <section className="omm-tab-view">
      <header className="omm-tab-view__header">
        {tabs.map((item) => (
          <button
            key={item.title}
            onClick={() => setTab(item.title)}
            className={classNames('omm-tab-view__tab', {
              'omm-tab-view__tab--active': tab === item.title,
            })}
          >
            {item.title}
          </button>
        ))}
      </header>
      <main className="omm-tab-view__content-view mac-scrollbar">
        {tabs.map((item) => (
          <div
            key={item.title}
            className={classNames(
              'omm-tab-view__content',
              `omm-tab-view__content--${item.title.replaceAll(' ', '-')}`,
              {
                'omm-tab-view__content--active': tab === item.title,
              }
            )}
          >
            {item.content}
          </div>
        ))}
      </main>
    </section>
  )
}

MediaMeasurementTabView.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.element.isRequired,
    }).isRequired
  ).isRequired,
}

MediaMeasurementTabView.defaultProps = {
  tabs: [
    {
      title: 'Default Tab',
      content: null,
    },
  ],
}

export default MediaMeasurementTabView
